import { Component, OnInit, Input } from "@angular/core";
import { TopNavBtn, TopNavDropdownItem } from "../../classes/navbar";
import { KpiService } from "../../kpi/kpi.service";

@Component({
  selector: "top-nav-dropdown",
  templateUrl: "./top-nav-dropdown.component.html",
  styleUrls: ["./top-nav-dropdown.component.scss"],
})
export class TopNavDropdownComponent implements OnInit {
  @Input() btnDetails: TopNavBtn;
  @Input() isBolded: boolean;
  @Input() isAdmin: boolean;
  @Input() isRestrictedUser: boolean;
  @Input() hasDataWall: boolean;
  @Input() rgpTenantId: string;

  constructor(public kpiService: KpiService) {}

  ngOnInit() {}

  canShowDropdownItem(dropdownItem: TopNavDropdownItem) {
    return (
      (dropdownItem.isAdminRestricted ? this.isAdmin : true) &&
      (dropdownItem.hideFromRestrictedUser ? !this.isRestrictedUser : true) &&
      (dropdownItem.needsDataWallSub ? this.hasDataWall : true)
    );
  }

  trackEvent(title) {
    this.kpiService.trackNavButtonClicked(title).subscribe();
  }
}
